import { getPersistedValue } from 'shared/utils/persisted-values';

import { isBrowser } from 'utils/misc-utils';
import { Session } from 'utils/session';

type SgtmEvent = {
  event_name: string;
  params: Record<string, unknown>;
};

type SgtmContext = {
  client_id: string;
  session_id?: string;
  user_id?: string;
};

type SgtmPayload = {
  dispensary_id: string;
  context: SgtmContext;
  events: SgtmEvent[];
};

export type SgtmClient = {
  post(data: SgtmPayload): Promise<void>;
};

const noop = (): Promise<void> => Promise.resolve();

async function post(data: SgtmPayload): Promise<void> {
  const session = Session.getInstance();
  const accessToken = getPersistedValue('access-token');

  const headers = {
    'Content-Type': 'application/json',
    Authorization: accessToken,
    ...session.header,
  };

  try {
    const resp = await fetch('/api/v2/analytics/events', {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });

    if (!resp.ok) {
      console.warn('[sgtm-client] non-ok response', resp.status);
    }
  } catch (err) {
    console.error('[sgtm-client]', err);
  }
}

export const createSgtmClient = (): SgtmClient => ({
  post: isBrowser() ? post : noop,
});
